import React from "react";
import PropTypes from "prop-types";
import { Authorized, DropDownItem } from "MODULES/shared/components";

const FilterOption = ({ filter, onClick }) => {
  const dropdownItem = [
    <DropDownItem
      key={filter.key || filter.label}
      onClick={() => onClick(filter.filters)}
    >
      {filter.label}
      {filter.hr && (
        <hr className="hr-xs hr-dashed" style={{ margin: "5px 0" }} />
      )}
    </DropDownItem>
  ];

  if (filter.withAuthorization) {
    return (
      <Authorized {...filter.withAuthorization}>{dropdownItem}</Authorized>
    );
  }

  return dropdownItem;
};

FilterOption.propTypes = {
  filter: PropTypes.shape({
    label: PropTypes.string.isRequired,
    filters: PropTypes.shape(),
    withAuthorization: PropTypes.shape({
      roles: PropTypes.arrayOf(PropTypes.string),
      authorizedIf: PropTypes.func
    })
  }).isRequired,
  onClick: PropTypes.func.isRequired
};

export default FilterOption;



// WEBPACK FOOTER //
// ./app/modules/shared/components/FilterSelect/FilterOption.jsx